/*
 * @Author: chengyu
 * @Date: 2022-09-22 17:08:22
 * @Description: 逆地理编码
 *
 * 自研：https://hellobike.yuque.com/rtyizx/ggpmnl/tol4kn
 * 高德：https://lbs.amap.com/api/webservice/guide/api/georegeo#regeo
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import amapReGeoCodingSearch from '../core/amap/reGeoCodingSearch';
import { ServiceTypeEnum } from '../core/enums';
import { AmapStandardEnum } from '../core/enums/lbs';
import lbsReGeoCodingSearch from '../core/lbs/reGeoCodingSearch';
import { createContext, createRgcContext } from '../core/request/fetchContext';
import { mergeDefaultOptions, noCacheOptions, services } from '../core/utils';
import { isArray, isString } from '../core/utils/is';
import { mapError } from '../core/utils/logger';
import { removeEmpty, removeEmptyString } from '../core/utils/transform';
var rgcContext = createRgcContext();
/**
 * 合并默认参数，并对入参进行格式化
 * @param params
 */
function mergeDefaultParams(params) {
    var defaultParams = {
        extensions: 'all',
    };
    var _params = __assign(__assign({}, defaultParams), params);
    // 去掉空值
    _params = removeEmpty(_params);
    // 去掉空字符串
    _params = removeEmptyString(_params);
    // `isAmapStandard`将字符串值，格式化为数字，内部逻辑判断使用的是`number`类型
    if ('isAmapStandard' in _params && isString(_params.isAmapStandard)) {
        _params.isAmapStandard = Number(_params.isAmapStandard);
    }
    return _params;
}
function reGeoCodingSearch(params, options) {
    return __awaiter(this, void 0, void 0, function () {
        var context, _options, _params, _a, firstRequest, lastRequest, _noCacheOptions, result, _result, data, _result, data, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    context = createContext({
                        rgc: rgcContext,
                    });
                    _options = __assign(__assign({ 
                        /**
                         * 默认：仅逆地理编码调用 先请求高德，兜底为哈罗lbs
                         * 传入`{serveSort: [...]}`参数可将其覆盖掉，从而使用自定义的顺序
                         */
                        serveSort: [ServiceTypeEnum.GAODE, ServiceTypeEnum.HELLO] }, mergeDefaultOptions(options)), { context: context, method: 'reGeoCodingSearch' });
                    _params = mergeDefaultParams(params);
                    _a = services(lbsReGeoCodingSearch, amapReGeoCodingSearch, _options), firstRequest = _a[0], lastRequest = _a[1];
                    _noCacheOptions = noCacheOptions(_options);
                    if (!lastRequest) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, firstRequest(_params, _options)];
                case 2:
                    result = _b.sent();
                    if (_params.isAmapStandard === AmapStandardEnum.GAODE) {
                        _result = result;
                        if (_result && _result.data && _result.data.data) {
                            data = _result.data.data.reGeoCodesListStandard;
                            if (isArray(data) && data.length > 0) {
                                return [2 /*return*/, result];
                            }
                        }
                    }
                    else {
                        _result = result;
                        if (_result && _result.data && _result.data.data) {
                            data = _result.data.data.reGeoCodesList;
                            if (isArray(data) && data.length > 0) {
                                return [2 /*return*/, result];
                            }
                        }
                    }
                    mapError('数据不完整，尝试降级到兜底服务获取数据');
                    return [2 /*return*/, lastRequest(_params, __assign(__assign({}, _noCacheOptions), { fallbackRegeo: true }))];
                case 3:
                    e_1 = _b.sent();
                    mapError('逆地理编码降级了，尝试降级到兜底服务获取数据', e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, lastRequest(_params, __assign(__assign({}, _noCacheOptions), { fallbackRegeo: true }))];
                case 5: return [2 /*return*/, firstRequest(_params, _options)];
            }
        });
    });
}
export default reGeoCodingSearch;
//# sourceMappingURL=data:application/json;base64,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